import { createAsyncAction } from '../reduxActions';

export const fetchVirtualEventsAction = createAsyncAction('GET_VIRTUAL_EVENTS');
export function fetchVirtualEvents(params, reqBody) {
  return { type: fetchVirtualEventsAction.toString(), params, reqBody };
}
